import { render, staticRenderFns } from "./TransfermarketView.vue?vue&type=template&id=5cd979dc&"
import script from "./TransfermarketView.vue?vue&type=script&lang=js&"
export * from "./TransfermarketView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports